import styled from "styled-components";
import { useState, useContext, useEffect, createContext } from "react";
import { userStateListener, listenAndSetCurrentUser } from "../Firebase";
import { SpinnerContext } from "./SpinnerContext";
import LoginComponent from "../Components/UI/Login/Login";
import NoUserPage from "../Components/UI/NoUserPage/NoUserPage";

import { User as FirebaseUser } from "firebase/auth";

const testUser = {
  lastName: "Benn",
  PCRoles: [
    {
      teamId: "A1B2C3D4F9",
      role: "volunteer" as RoleType,
    },
    {
      teamId: "A1B2C3D4F9",
      role: "oversight" as RoleType,
    },
  ],
  firebaseUid: ["pqjfvzgMKKQid9ZitX4YWmGixi23"],
  userId: "284200039023906",
  firstName: "Carolyne",
  email: ["carolyne.benn@volunteer.hillsong.com"],
};

interface CurrentUserContext {
  currentUser: UserData | null;
  currentFirebaseUser: FirebaseUser | null;
}

export const CurrentUserContext = createContext<CurrentUserContext | null>(
  null
);

export default function CurrentUserContextProvider(props: Props) {
  const spinnerContext = useContext(SpinnerContext);
  const [currentUser, setCurrentUser] = useState<UserData | null>(null);
  const [firebaseUser, setFirebaseUser] = useState<FirebaseUser | null>(null);

  useEffect(() => {
    const unsubscribeFromFirebaseUser = userStateListener((user) => {
      if (user) {
        setFirebaseUser(user);
        spinnerContext.setIsLoading(false);
        console.log("User logged in");
      } else {
        setFirebaseUser(null);
        setCurrentUser(null);
        spinnerContext.setIsLoading(false);
        console.log("No user logged in");
      }
    });
    return () => unsubscribeFromFirebaseUser();
  }, []);

  useEffect(() => {
    if (!firebaseUser || !firebaseUser.providerData[0].email) return;
    if (currentUser) {
      spinnerContext.setIsLoading(false);
    }
    const unsubscribeFromMatchingUser = listenAndSetCurrentUser(
      firebaseUser.uid,
      firebaseUser.providerData[0].email,
      (user) => {
        if (!user || user.PCRoles.length === 0) return;
        setCurrentUser(user);
        //setCurrentUser(testUser);
        spinnerContext.setIsLoading(false);
      }
    );

    spinnerContext.setIsLoading(false);
    return () => unsubscribeFromMatchingUser();
  }, [firebaseUser]);
  console.log("currentUser", firebaseUser);

  return (
    <CurrentUserContext.Provider
      value={{ currentUser: currentUser, currentFirebaseUser: firebaseUser }}
    >
      {!firebaseUser && <LoginComponent />}
      {(firebaseUser && !currentUser) && <NoUserPage />}
      {(firebaseUser && currentUser) && props.children}
    </CurrentUserContext.Provider>
  );
}

interface Props {
  children: React.ReactNode;
}
